import { SignInPage } from '@backstage/core-components';
import { githubAuthApiRef } from '@backstage/frontend-plugin-api';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';

// The core-components SignInPage prop types are a union that hides the
// multi-provider variant from inference; the runtime accepts `providers`
// together with the blueprint-injected sign-in handlers.
const DevSignInPage = (props: any) => {
  // Local-dev convenience (the security review removed the guest DEFAULT,
  // not the explicit card). The 'guest' string resolves to the built-in
  // core-components provider; drop this entry before shipping to prod.
  const providers: any[] = [
    {
      id: 'github-auth-provider',
      title: 'GitHub',
      message: 'Sign in using GitHub',
      apiRef: githubAuthApiRef,
    },
    'guest',
  ];
  return <SignInPage {...props} providers={providers} />;
};

export const signInPage = SignInPageBlueprint.make({
  params: {
    loader: async () => props => <DevSignInPage {...props} />,
  },
});
